type Props = {
  color?: string;
};

export default function ArrowIcon({
  color = "var(--brand-primary-color)",
}: Props) {
  return (
    <svg
      width="11"
      height="16"
      viewBox="0 0 11 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.00007 14.0001L8.00014 8L2.00007 1.99993"
        stroke={color}
        strokeWidth="3"
      />
    </svg>
  );
}
